import { Header } from '@uofu-uss-gis/ui-react';
import { useAuthStore } from '../../store/authStore';
import { useTheme } from '@mui/material/styles';

/**
 * Wrapper component for the Header that conditionally shows search and filters
 * based on authentication status.
 * 
 * The search bar and filter buttons are hidden until the user is authenticated.
 * When authenticated, a logout button is displayed in the top-right corner.
 */
const AuthenticatedHeader = () => {
  const { isAuthenticated, logout, user } = useAuthStore();
  const theme = useTheme();

  if (!isAuthenticated) {
    return (
      <header className="absolute top-5 left-5 z-50 flex flex-col md:flex-row md:items-center items-center gap-2">
        <div className="shadow-md rounded-md w-full md:w-96" style={{ backgroundColor: theme.palette.background.paper }}>
          <div className="flex items-center rounded-l px-4 py-2">
            <a
              href="https://utah.edu"
              target="_blank"
              rel="noopener noreferrer"
              className="mr-2"
              aria-label="Visit University of Utah homepage"
            >
              <img
                src="/app/resources/images/Ulogo.png"
                alt="University of Utah Logo"
                className="h-5 w-auto cursor-pointer"
                width={20}
                height={20}
              />
            </a>
            <span className="text-sm ml-2" style={{ color: theme.palette.text.secondary }}>
              Log in to search the campus map
            </span>
          </div>
        </div>
      </header>
    );
  }

  return (
    <>
      <Header />
      <div className="hidden lg:block absolute top-5 right-5 z-50">
        <button
          type="button"
          onClick={logout}
          className="shadow-md rounded-md px-4 py-2 hover:shadow-lg transition-shadow flex items-center gap-2"
          style={{ backgroundColor: theme.palette.background.paper }}
          aria-label="Logout"
        >
          <span className="text-sm font-semibold" style={{ color: theme.palette.text.primary }}>
            {user?.name || 'User'}
          </span>
          <span style={{ color: theme.palette.text.disabled }}>|</span>
          <span className="text-sm" style={{ color: theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.primary.main }}>
            Logout
          </span>
        </button>
      </div>
    </>
  );
};

export default AuthenticatedHeader;
